export default {
  geolocation: {
    lat: '-33.92528',
    lng: '18.42389',
    label: '8301 Cape Town',
  },
  price_rules: {
    grouping: ',',
    decimal: '.',
  },
}
